import app from 'app';

app.namespace.Controller.GoogleDrivePicker = new (class {
  constructor() {
    // The Browser API key obtained from the Google API Console.
    this.developerKey =
      serverProfile.environment === 'prod'
        ? 'AIzaSyAscfjLHeSc45JJLCFbu9yi_2_0RJBpnAs'
        : 'AIzaSyCZozHVvGexGKuFaQQ8eIJWkFbEdkhwgYA';

    // The Client ID obtained from the Google API Console.
    this.clientId =
      serverProfile.environment === 'prod'
        ? '330891918815-af1oo9gubs48mk372p5nael6ih1urqtc.apps.googleusercontent.com'
        : '304559170780-h65c86ml44mcf5hfqaf4k588r0ptd52k.apps.googleusercontent.com';

    // Scope to use to access user's photos.
    this.scope = 'https://www.googleapis.com/auth/drive.readonly';

    this.pickerApiLoaded = false;
    this.oauthToken = null;
  }

  openPicker() {
    return new Promise((resolve, reject) => {
      gapi.auth2.authorize(
        {
          client_id: this.clientId,
          scope: this.scope,
        },
        (authResult) => {
          if (authResult && !authResult.error) {
            this.oauthToken = authResult.access_token;
            this._createPicker()
              .then((files) => {
                resolve(files);
              })
              .catch(reject);
          } else {
            app.dialog.error({
              type: app.dialog.types.ERROR_2,
              buttonYesText: 'Close',
              title: 'Google Authentication Failed',
              description: authResult.details,
              showContactCsm: true,
            });
          }
        }
      );
    });
  }

  _createPicker() {
    return new Promise((resolve, reject) => {
      const view = new google.picker.DocsView()
        .setParent('root')
        .setIncludeFolders(true);

      // list had to be hard-coded, backend doesn't provide allowed mime types
      view.setMimeTypes(
        'image/png,image/jpeg,image/jpg,image/gif,image/bmp,video/x-dv' +
          'video/mts,video/mxf,video/dv,video/mp4,video/avi,video/x-msvideo,video/webm,video/mpeg,' +
          'video/webm,video/ogg,video/quicktime,video/x-matroska,video/x-ms-wmv,video/x-flv,video/3gpp,video/3gpp2'
      );

      const picker = new google.picker.PickerBuilder()
        .addView(view)
        .addView(google.picker.ViewId.DOCS_IMAGES_AND_VIDEOS)
        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setOAuthToken(this.oauthToken)
        .setDeveloperKey(this.developerKey)
        .setCallback((data) => {
          if (
            data[google.picker.Response.ACTION] == google.picker.Action.PICKED
          ) {
            const downloadToken = gapi.auth.getToken().access_token;
            const files = [];
            data[google.picker.Response.DOCUMENTS].forEach((file) => {
              file.downloadToken = downloadToken;
              files.push(file);
            });
            resolve(files);
          } else if (
            data[google.picker.Response.ACTION] == google.picker.Action.CANCEL
          ) {
            reject();
          }
        })
        .build();
      picker.setVisible(true);
    });
  }
})();
